import * as THREE from "three"
import Experience from "./Experience.js"
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js"

export default class Camera {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.camera = this.experience.camera

        this.setInstance()
        this.setControls()
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            75,
            this.sizes.width / this.sizes.height,
            7,
            100000
        )
        this.instance.position.set(
            111.37890433728003,
            387.68420846962164, -563.2479195500744
        )
        this.scene.add(this.instance)
        this.pivot = new THREE.Vector3()
        this.instance.getWorldDirection(this.pivot)
    }

    setControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.target.set(-64.5743482624077, -4.219499870371941, -50.97131685099222)
        this.controls.enableDamping = true
        this.controls.minDistance = 60
        this.controls.maxDistance = 900
        this.controls.minPolarAngle = Math.PI / 12
        this.controls.maxPolarAngle = Math.PI / 2.15
        this.controls.enablePan = true
        this.controls.autoRotate = true
        this.controls.screenSpacePanning = true
        this.controls.autoRotateSpeed = 0.4
        this.controls.dampingFactor = 0.05
        this.controls.enableZoom = true
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update() {
        // console.log(this.instance.position)
        // console.log(this.controls.target)
        this.controls.update()
    }
}